<template>
    <el-dialog
        :visible.sync="dialogVisible"
        width="30%"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        class="festival-cycle-adjustment"
    >
        <div
            slot="title"
            class="title"
        >
            <i class="el-color-warning el-icon-warning"></i> 节日送货周期调整提醒
        </div>
        <div>
            <div>尊敬的供应商合作伙伴：</div>
            <div class="content">
                为配合<span>{{ festivalConfig && festivalConfig.festivalName }}</span>假期安排，确保节日期间物流配送有序进行，现开放送货周期配置调整窗口期：<span>{{ festivalConfig && festivalConfig.adjustStartDate }} ~ {{ festivalConfig && festivalConfig.adjustEndDate }}</span>可调整订货日、到货日，如需调整请点击去调整跳转入口或稍后到【供应协同】-【节日送货周期】入口调整。如无需修改请忽略本消息，节日期间依然按当前送货周期订货，祝您假期愉快。
            </div>
        </div>
        <span
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                type="primary"
                @click="handleComfirm"
            > 去调整 </el-button>
            <el-button @click="handleCancel"> 无需调整，关闭提醒 </el-button>
        </span>
    </el-dialog>
</template>

<script>

export default {
    props: {
        supplierId: {
            type: Number,
            default: -1,
        },
    },
    data() {
        return {
            dialogVisible: false,
            festivalConfig: {},
        };
    },
    created() {
        this.getFestivalCycleAdjustment();
    },
    methods: {
        async getFestivalCycleAdjustment() {
            if (this.supplierId === -1 || sessionStorage.getItem('remindFlag') === 'false') {
                return;
            }
            const res = await this.$hPost('/api/scm/shepherd/ars/rdc/festival/deliver/adjust/remind', { supplierId: this.supplierId });
            if (res) {
                this.festivalConfig = res.festivalConfig;
                this.dialogVisible = res.remindFlag;
            }
        },
        handleComfirm() {
            sessionStorage.setItem('remindFlag', false);
            this.$tools.linkTo('/festivalDeliveryCycle.html');
            this.dialogVisible = false;
        },
        async handleCancel() {
            await this.$hPost('/api/scm/shepherd/ars/rdc/festival/deliver/adjust/closeRemind', { supplierId: this.supplierId, configId: this.festivalConfig.configId });
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.festival-cycle-adjustment {
  .title {
    font-weight: bold;
    text-align: left;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .content {
    text-indent: 2em;
    span{
        color: #1fd535;
    }
  }
}
.el-color-warning{
    color: #e6a23c;
    font-size: 18px;
    margin: 0 20px;
}
</style>
